"use strict";
exports.__esModule = true;
var binary_search_1 = require("./binary_search");
var i18n_1 = require("./i18n");
exports.timeAgoReset = i18n_1.reset;
exports.timeAgoSet = i18n_1.set;
var Unit;
(function (Unit) {
    Unit["Years"] = "year";
    Unit["Months"] = "month";
    Unit["Days"] = "day";
    Unit["Hours"] = "hour";
    Unit["Minutes"] = "minute";
})(Unit || (Unit = {}));
var Tense;
(function (Tense) {
    Tense[Tense["Past"] = 0] = "Past";
    Tense[Tense["Future"] = 1] = "Future";
})(Tense || (Tense = {}));
var TimeSpan = (function () {
    function TimeSpan(unit, tense, value) {
        this.unit = unit;
        this.tense = tense;
        this.value = value;
    }
    TimeSpan.prototype.template = function () {
        if (this.unit === Unit.Minutes && this.value === 0 && this.tense === Tense.Future) {
            return "in a minute";
        }
        else if (this.unit === Unit.Minutes && this.value === 0 && this.tense === Tense.Past) {
            return "less than a minute ago";
        }
        else if (this.tense === Tense.Past) {
            return "%s " + this.noun() + " ago";
        }
        else if (this.tense === Tense.Future) {
            return "in %s " + this.noun();
        }
        else {
            throw new Error("Tense cannot be handled: " + this.tense);
        }
    };
    TimeSpan.prototype.noun = function () {
        if (this.value > 1) {
            return this.unit + "s";
        }
        return this.unit;
    };
    return TimeSpan;
}());
var minuteRanges = [
    {
        key: Number.NEGATIVE_INFINITY,
        tense: Tense.Future,
        unit: Unit.Years,
        valueResolver: function (m) { return parseInt(Math.abs(m / 525960).toFixed(), 10); }
    },
    {
        key: -529600,
        tense: Tense.Future,
        unit: Unit.Years,
        valueResolver: function (_) { return 1; }
    },
    {
        key: -486400,
        tense: Tense.Future,
        unit: Unit.Months,
        valueResolver: function (m) { return parseInt(Math.abs(m / 43200).toFixed(), 10); }
    },
    {
        key: -43200,
        tense: Tense.Future,
        unit: Unit.Months,
        valueResolver: function (_) { return 1; }
    },
    {
        key: -41760,
        tense: Tense.Future,
        unit: Unit.Days,
        valueResolver: function (m) { return parseInt(Math.abs(m / 1440).toFixed(), 10); }
    },
    {
        key: -1440,
        tense: Tense.Future,
        unit: Unit.Days,
        valueResolver: function (_) { return 1; }
    },
    {
        key: -1380,
        tense: Tense.Future,
        unit: Unit.Hours,
        valueResolver: function (m) { return parseInt(Math.abs(m / 60).toFixed(), 10); }
    },
    {
        key: -45,
        tense: Tense.Future,
        unit: Unit.Hours,
        valueResolver: function (_) { return 1; }
    },
    {
        key: -44,
        tense: Tense.Future,
        unit: Unit.Minutes,
        valueResolver: function (m) { return parseInt(Math.abs(m).toFixed(), 10); }
    },
    {
        key: -1,
        tense: Tense.Future,
        unit: Unit.Minutes,
        valueResolver: function (_) { return 0; }
    },
    {
        key: 0,
        tense: Tense.Past,
        unit: Unit.Minutes,
        valueResolver: function (_) { return 0; }
    },
    {
        key: 1,
        tense: Tense.Past,
        unit: Unit.Minutes,
        valueResolver: function (_) { return 1; }
    },
    {
        key: 2,
        tense: Tense.Past,
        unit: Unit.Minutes,
        valueResolver: function (m) { return parseInt(m.toFixed(), 10); }
    },
    {
        key: 45,
        tense: Tense.Past,
        unit: Unit.Hours,
        valueResolver: function (_) { return 1; }
    },
    {
        key: 90,
        tense: Tense.Past,
        unit: Unit.Hours,
        valueResolver: function (m) { return parseInt((m / 60).toFixed(), 10); }
    },
    {
        key: 1440,
        tense: Tense.Past,
        unit: Unit.Days,
        valueResolver: function (_) { return 1; }
    },
    {
        key: 2880,
        tense: Tense.Past,
        unit: Unit.Days,
        valueResolver: function (m) { return parseInt((m / 1440).toFixed(), 10); }
    },
    {
        key: 43200,
        tense: Tense.Past,
        unit: Unit.Months,
        valueResolver: function (_) { return 1; }
    },
    {
        key: 86400,
        tense: Tense.Past,
        unit: Unit.Months,
        valueResolver: function (m) { return parseInt((m / 43200).toFixed(), 10); }
    },
    {
        key: 529600,
        tense: Tense.Past,
        unit: Unit.Years,
        valueResolver: function (_) { return 1; }
    },
    {
        key: 1051200,
        tense: Tense.Past,
        unit: Unit.Years,
        valueResolver: function (m) { return parseInt((m / 525960).toFixed(), 10); }
    },
    {
        key: Number.MAX_VALUE,
        tense: null,
        unit: null,
        valueResolver: function (_) { return null; }
    },
];
function getTimeSpan(from, to) {
    var minutes = (+to - +from) / 60000;
    var match = binary_search_1.binarySearch(minuteRanges, minutes);
    return new TimeSpan(match.unit, match.tense, match.valueResolver(minutes));
}
function timeAgoInWords(from, to) {
    if (to === void 0) { to = new Date(); }
    var timeSpan = getTimeSpan(from, to);
    return i18n_1.translate(timeSpan.template(), timeSpan.value.toString());
}
exports.timeAgoInWords = timeAgoInWords;
//# sourceMappingURL=time_ago.js.map